import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
//custom imports
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import FilterData from './TransactionDownload'
//import Actions from "./components/Actions";
//import TabPanel from "./components/Tab"
//
function TransactionDownloadData() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <br />
      <Grid >
        <FilterData />
      </Grid>
      <Footer />
    </DashboardLayout>
  );
}
export default TransactionDownloadData;
